import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useTotalUser from "../../utils/useTotalUser";

function StatsBar() {
    const { isLogined } = useSelector((state) => state.auth);
    const totalRefunded = 300000000;
    const [isChecking, setIsChecking] = useState(true); // Mặc định giả sử đã login, đang check
    // Chỉ fetch khi đã check xong và xác nhận chưa login
    const shouldFetch = !isChecking && !isLogined;
    const { totalUser } = useTotalUser(shouldFetch);

    useEffect(() => {
        // Check xem có token không
        const hasToken = !!localStorage.getItem('access_token');
        
        if (hasToken) {
            // Nếu có token, đợi một chút để auth check xong
            if (isLogined) {
                // Đã login, không cần check nữa
                setIsChecking(false);
            } else {
                // Có token nhưng isLogined vẫn false, đợi check xong
                const timer = setTimeout(() => {
                    setIsChecking(false);
                }, 500);
                return () => clearTimeout(timer);
            }
        } else {
            // Không có token, chắc chắn chưa login, check xong
            setIsChecking(false);
        }
    }, [isLogined]);

    // Mặc định giả sử đã login (không hiển thị), chỉ hiển thị khi check xong và chưa login
    if (isChecking || isLogined) return null;

    return (
        <div className="bg-surface rounded-md">
            <div className="flex justify-between py-2">
                <div className="flex flex-1 flex-col justify-center items-center text-center">
                    <span className="text-xl text-brand-red font-bold">1.000.000+</span>
                    <span>Đơn hàng</span>
                </div>
                <div className="flex justify-center items-center py-2">
                    <div className="border-l border-line-strong h-full"></div>
                </div>
                <div className="flex flex-1 flex-col justify-center items-center text-center">
                    <span className="text-xl text-brand-red font-bold">{totalUser.toLocaleString("vi-VN") || "..."}</span>
                    <span>Thành viên</span>
                </div>
                <div className="flex justify-center items-center py-2">
                    <div className="border-l border-line-strong h-full"></div>
                </div>
                <div className="flex flex-1 flex-col justify-center items-center text-center">
                    <span className="text-xl text-brand-red font-bold">{(totalRefunded / 1000000).toFixed(0)}M+</span>
                    <span>Đã hoàn</span>
                </div>
            </div>
        </div>
    );
}

export default StatsBar;

